import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable , of} from 'rxjs';
import { environment } from '../../environments/environment';

import { FuncionalidadeResponse } from '../_models/response/funcionalidadeResponse';
import { Funcionalidade } from '../_models/funcionalidade/funcionalidade';
import { Aplicacao } from '../_models/usuario/aplicacao';

export const HTTP_OPTIONS = {
  headers: new HttpHeaders({
    'Content-Type':  'application/json',
    'Access-Control-Allow-Credentials' : 'true',
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Methods': 'GET, POST, PATCH, DELETE, PUT, OPTIONS',
    'Access-Control-Allow-Headers': 'Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With',
  })
};

@Injectable({ providedIn: 'root' })
export class FuncionalidadeService {

   constructor(private http: HttpClient) { }

   getAll() {
     return this.http.get<Funcionalidade[]>(`${environment.authorizedUrls.bsCobrancaUrl}/funcionalidade/listarTodos`);
  }

  inserir(funcionalidade: Funcionalidade): Observable<FuncionalidadeResponse> {
    return this.http.post<FuncionalidadeResponse>(`${environment.authorizedUrls.bsCobrancaUrl}/funcionalidade/incluir`, {
      funcionalidade
    });
  }

  atualizar(funcionalidade: Funcionalidade): Observable<FuncionalidadeResponse> {
     return this.http.post<FuncionalidadeResponse>(`${environment.authorizedUrls.bsCobrancaUrl}/funcionalidade/atualizar`, {
      funcionalidade
    });
  }

  deletar(funcionalidade: Funcionalidade): Observable<FuncionalidadeResponse> {
    return this.http.post<FuncionalidadeResponse>(`${environment.authorizedUrls.bsCobrancaUrl}/funcionalidade/excluir`, {
      funcionalidade
    });
  }

}
